import { Directive, ElementRef, afterRenderEffect, contentChildren } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

@Directive({
    selector: '[msScrollTo]',
    standalone: false,
})
export class ScrollToDirective {
    items = contentChildren('msScrollToItem');

    element: HTMLElement;

    constructor(
        private elm: ElementRef,
        private deviceService: DeviceService,
    ) {
        this.element = this.elm.nativeElement;
        afterRenderEffect(() => {
            const orientation = this.deviceService.orientationSignal();
            if (orientation && this.items().length > 0) {
                this.changeScroll();
            }
        });
    }

    private changeScroll = (): void => {
        if (this.element.scrollWidth > this.element.offsetWidth) {
            this.element.scrollLeft = this.element.scrollWidth;
        }
    };
}
